// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"menuWrapper__3brmD","display":"display__3KBPn","triggerWrapper":"triggerWrapper__11nmz","overlayWrapper":"overlayWrapper__24xZA"};